import { render, staticRenderFns } from "./FareGroupAdditionalDetails.vue?vue&type=template&id=af7b8274&"
import script from "./FareGroupAdditionalDetails.vue?vue&type=script&lang=js&"
export * from "./FareGroupAdditionalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports